import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdminDialogType } from './add-amin-dialog.vm';
import { AddAdminDialogService } from './add-admin-dialog.service';

@Component({
  selector: 'app-add-admin-dialog',
  templateUrl: './add-admin-dialog.component.html',
  styleUrls: ['./add-admin-dialog.component.scss'],
  providers: [AddAdminDialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddAdminDialogComponent {
  protected passwordVisible = false;
  protected addAdminFormGroup = this.addAdminDialogService.getAddAdminFormGroup(AdminDialogType.Add);

  constructor(private addAdminDialogService: AddAdminDialogService) {}

  protected togglePasswordVisible() {
    this.passwordVisible = !this.passwordVisible;
  }

  protected onSubmit() {
    if (this.addAdminFormGroup.valid) {
      this.addAdminDialogService.submitForm();
    } else {
      this.addAdminFormGroup.markAllAsTouched();
    }
  }
}
